module.exports = __webpack_public_path__ + "static/media/pdfdefault.96d299e6.png";